var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"container-banner"},[_c('HeadLine'),_c('HeadingVideo')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }